import { useState } from "react";
import { findParamInLocalStorage } from "../../../../utils/getAnyDataLocalStorge";
export var useLocalStorageData = function () {
    var Quote = useState(findParamInLocalStorage("Quote"))[0];
    var quoteId = Quote === null || Quote === void 0 ? void 0 : Quote.id;
    var User = useState(findParamInLocalStorage("user", "assurehub"))[0];
    var Plan = useState(findParamInLocalStorage("Plan"))[0];
    var valuePlanId = Plan === null || Plan === void 0 ? void 0 : Plan["0"].id;
    var projectId = useState(findParamInLocalStorage("projectId"))[0];
    return {
        Quote: Quote,
        quoteId: quoteId,
        User: User,
        Plan: Plan,
        valuePlanId: valuePlanId,
        projectId: projectId,
    };
};
